import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormContext } from 'contexts';

import {
  AuFormItemWrapper,
  AuDirectionLink
} from 'components/DTA';
import { urlSelector } from 'PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from 'components/Portal/Utilities';
import { useFormikContext } from 'formik';
import { getIdentityDocumentTitleAndDataModel } from 'helpers/arnApplicationHelper';
import { PoiVerificationApplicationFormData } from 'types/forms/arnApplicationTypes';
import { IDENTITY_TYPES } from 'arnConstants';

interface UserDetails { userdetails: unknown; };

const FinalPoiStep: React.FC = () => {
  const { values, getFieldMeta } = useFormikContext<PoiVerificationApplicationFormData>();
  const userdetails = useSelector((state: UserDetails) => state.userdetails);
  const userDetailsValue: any = userdetails;
  const userEmail = userDetailsValue.items.value[0].emailaddress1;
  const urlHome = useSelector((state: any) => urlSelector(state, 'Portal - Home URL'));
  const { formAlert } = useContext(FormContext);

  const handleBackToDashBoard = () => {
    if (formAlert && formAlert[0] && formAlert[0].as === 'success') {
      sessionStorage.setItem('casa.indarnsCount', '1'); //TODO need to change the session storage item
    }
    const dashboardUrl = getPortalUrl('/dashind', false, urlHome);
    window.location.href = dashboardUrl;
  };

  let isDvsPassed = false;
  if (values.identityType && values.identityType !== IDENTITY_TYPES.MANUAL_UPLOAD) {
    const identityType = getIdentityDocumentTitleAndDataModel(values.identityType);
    const dvsValidationIndicator = getFieldMeta(`${identityType.identityType}.dvsValidationIndicator`).value;
    isDvsPassed = dvsValidationIndicator === 'Passed';
  };

  return (
    <>
      {
        formAlert &&
        formAlert[0] &&
        formAlert[0].as === 'success' &&
        <div style={{ marginTop: '30px' }}>
          <AuFormItemWrapper>
            {isDvsPassed && <><p>
              Thank you for linking your aviation reference number.
              We are processing your request. Once complete we will send an email confirming your linked aviation reference number to <strong>{userEmail}</strong>.
            </p>
            <p>You should receive this email within the next 2 minutes.</p>
            </>}
            {!isDvsPassed && <><p>
              Thank you for creating an account and linking your aviation reference number.
              We are processing your request and will aim to have your application completed within five business days.
              Once complete we will send an email confirming your aviation reference number to <strong>{userEmail}</strong>.
            </p>
            </>}
          </AuFormItemWrapper>
          <br />
        </div>
      }
      <AuFormItemWrapper>
        <AuDirectionLink onClick={handleBackToDashBoard} text="Return to myCASA" direction="left" />
      </AuFormItemWrapper>
    </>
  );

};

export default FinalPoiStep;